import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { message } from 'antd';
import ErrorBoundary from './ErrorBoundary';
import { createBrowserHistory } from 'history';
import { saveState } from 'stateStorage';

export const history = createBrowserHistory();

export const sessionTimeout = () => message.warning('Session timed out, please re-login');

window.onbeforeunload = () => {
  if (store.getState().signIn.userId) {
    saveState(store.getState());
  }
};

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
